'use client'

import { FlipHorizontal, FlipVertical, RotateCcwSquare, RotateCwSquare } from 'lucide-react'
import { useMemo } from 'react'
import { ToolbarButtonGroup } from './ToolbarButtonGroup'
import type { CropToolbarProps } from './types'

export function CropToolbar({ onRotateLeft, onRotateRight, onFlipHorizontal, onFlipVertical }: CropToolbarProps) {
  const rotateButtons = useMemo(
    () => [
      {
        icon: RotateCcwSquare,
        onClick: onRotateLeft,
        title: 'Rotate Left',
      },
      {
        icon: RotateCwSquare,
        onClick: onRotateRight,
        title: 'Rotate Right',
      },
    ],
    [onRotateLeft, onRotateRight],
  )

  const flipButtons = useMemo(
    () => [
      {
        icon: FlipHorizontal,
        onClick: onFlipHorizontal,
        title: 'Flip Horizontal',
      },
      {
        icon: FlipVertical,
        onClick: onFlipVertical,
        title: 'Flip Vertical',
      },
    ],
    [onFlipHorizontal, onFlipVertical],
  )

  return (
    <div className='grid grid-cols-2 gap-4 w-full'>
      <ToolbarButtonGroup label='Rotate' buttons={rotateButtons} />
      <ToolbarButtonGroup label='Flip' buttons={flipButtons} />
    </div>
  )
}
